export const RANGO_SALARIAL_PERFIL_LABELS = {
  // Navigation
  administration: 'Administración',
  rangoSalarialPerfil: 'Rango Salarial por Perfil',

  // Actions
  createRangoSalarialPerfil: 'Crear Rango Salarial',
  editRangoSalarialPerfil: 'Editar Rango Salarial',
  viewRangoSalarialPerfil: 'Ver Rango Salarial',
  save: 'Guardar',
  cancel: 'Cancelar',
  confirm: 'Confirmar',
  close: 'Cerrar',

  // Form fields
  rangoSalarialId: 'ID de Rango Salarial',
  perfilId: 'Perfil',
  perfil: 'Perfil',
  ano: 'Ano',
  minimo: 'Salario Mínimo',
  maximo: 'Salario Máximo',
  selectPerfil: 'Seleccionar Perfil',
  notSelected: 'Sin perfil seleccionado',

  // Table
  tableId: 'ID',
  tablePerfil: 'Perfil',
  tableAno: 'Año',
  tableMinimo: 'Mínimo',
  tableMaximo: 'Máximo',
  tableActions: 'Acciones',

  // Status
  active: 'Activo',
  inactive: 'Inactivo',

  // Messages
  loadingRangosSalariales: 'Cargando rangos salariales...',
  noRangosSalariales: 'No hay rangos salariales disponibles',
  rangoSalarialCreated: 'Rango salarial creado exitosamente',
  rangoSalarialUpdated: 'Rango salarial actualizado exitosamente',
  rangoSalarialDeleted: 'Rango salarial eliminado exitosamente',
  confirmDelete: '¿Está seguro de que desea eliminar este rango salarial?',
  errorLoading: 'Error al cargar los rangos salariales',
  errorCreating: 'Error al crear el rango salarial',
  errorUpdating: 'Error al actualizar el rango salarial',
  errorDeleting: 'Error al eliminar el rango salarial',
  errorValidation: 'Error de validación',
  requiredField: 'Campo requerido',
  invalidYear: 'El año debe ser mayor a 2000',
  invalidMinimo: 'El salario mínimo debe ser mayor a 0',
  invalidMaximo: 'El salario máximo debe ser mayor al mínimo',
  duplicateYear: 'Ya existe un rango salarial para este perfil y año',

  // Search and filters
  search: 'Buscar',
  searchPlaceholder: 'Buscar por perfil, año...',
  clearFilters: 'Limpiar filtros',
  noData: 'No hay datos disponibles',

  // Validation messages
  perfilRequired: 'Debe seleccionar un perfil',
  anoRequired: 'El ano es requerido',
  minimoRequired: 'El salario mínimo es requerido',
  maximoRequired: 'El salario máximo es requerido',
  anoMinValue: 'El año debe ser mayor o igual a 2000',
  anoMaxValue: 'El año no puede ser más de 10 años en el futuro',
  minimoMinValue: 'El salario mínimo debe ser mayor o igual a 0',
  maximoMinValue: 'El salario máximo debe ser mayor o igual a 0',
  maximoGreaterThanMinimo: 'El salario máximo debe ser mayor al mínimo',
  duplicatePerfilAno: 'Ya existe un rango salarial para este perfil y año'
} as const;
